import type { RouteRecordRaw } from 'vue-router';

const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const MultiTransaction = () => import('@/modules/multiTransactionV2/pages/MultiTransaction/index.vue');

export const multiTransactionRoutes: Array<RouteRecordRaw> = [
  {
    path: '/multi-transaction',
    name: 'multi-transaction',
    redirect: {
      name: 'multi-transaction-index',
    },
    component: EmptyLayout,
    meta: {
      title: 'Operaciones masivas',
      subTitle: 'last-connection',
      accessRol: {
        section: 'TRANSACTIONS',
        actions: ['MULTI_SEND'],
      },
    },
    children: [
      {
        path: '',
        name: 'multi-transaction-index',
        component: MultiTransaction,
      },
    ],
  },
];
